<indicator-wiz-navigation [stepNumber]="2"  [parentLocalSaveFunction]="saveBoundCallback"></indicator-wiz-navigation>
<div id="surveyCreator">
    <survey-creator [model]="surveyCreatorModel"></survey-creator>
</div>
